import * as Yup from "yup";

export const MAX_PRODUCT_IMAGES = 5;

const schema = Yup.object({
  name: Yup.string().required("The name field is required"),
  purchaseCost: Yup.number()
    .typeError("Purchase cost must be a number")
    .min(0, "Purchase cost cannot be negative")
    .required("Purchase cost is required"),
  standardRate: Yup.number()
    .typeError("Standard rate must be a number")
    .moreThan(0, "Standard rate must be greater than 0")
    .required("Standard rate is required"),
  isActive: Yup.boolean(),
  manufacturer: Yup.string().required("The manufacturer field is required"),
  brand: Yup.string().required("The brand field is required"),
  existingFiles: Yup.array().of(Yup.string()).optional(),
  images: Yup.array().of(Yup.mixed()).default([]),
  productTypeId: Yup.string().required("The type field is required"),
  categoryId: Yup.string().required("Category is required"),
  materialId: Yup.string().nullable().optional(),
  specification: Yup.string().nullable(),
  description: Yup.string().required("The description field is required"),
  deletedFiles: Yup.array().of(Yup.number()).optional().nullable(),
}).test("product-images-count", "Invalid product images", function (value) {
  const existing = Array.isArray(value?.existingFiles)
    ? value.existingFiles.length
    : 0;
  const files = Array.isArray(value?.images) ? value.images.length : 0;
  const total = existing + files;
  if (total < 1) {
    return this.createError({
      path: "images",
      message: "At least one image is required.",
    });
  }
  if (total > MAX_PRODUCT_IMAGES) {
    return this.createError({
      path: "images",
      message: `A product can have at most ${MAX_PRODUCT_IMAGES} images total (saved and new).`,
    });
  }
  return true;
});

export default schema;
